import React from 'react'

import WhiteBox from '../../components/WhiteBox'
import BorderButton from '../../components/BorderButton'

const NewLicenseHeader = ({ onNext, onCancel, nextEnabled }) => (
    <div className="row justify-content-center">
        <div className="col-10">
            <WhiteBox>
                <div
                    style={{
                        position: 'relative',
                        paddingRight: 100
                    }}>
                    <div className="row">
                        <div className="col-3">
                            <img src="/img/license/illy-license.svg" alt="" />
                        </div>
                        <div className="col-9">
                            <h3
                                style={{
                                    marginTop: 26
                                }}>
                                New license
                            </h3>

                            <p
                                style={{
                                    fontSize: 'smaller',
                                    color: '#797979'
                                }}>
                                License your Audiences and make them available to be used in your Campaign targeting
                            </p>

                            <p>Select the Audience you would like to License from the list below:</p>

                            <div className="new-segment-based-audience new-segment-based-audience--button-group" style={{ marginTop: '40px' }}>
                                <BorderButton className="grey" label="Cancel" onClick={onCancel} />
                                <BorderButton className="very-blue" label="Next" disabled={!nextEnabled} onClick={onNext} />
                            </div>
                        </div>
                    </div>
                </div>
            </WhiteBox>
        </div>
    </div>
)

export default NewLicenseHeader
